import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";

const getComplaintForLeaderLegal = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/ComplaintForLeaderLegal",
    params
  );
};

export { getComplaintForLeaderLegal };
